export type ClientError = {
  status_code: number;
  status_text: string;
  status_id?: string;
};

export function isClientSafeError(e: unknown): e is ClientSafeError {
  try {
    const parsed = JSON.parse((e as Error).message) as ClientError;
    return Boolean(parsed.status_code && parsed.status_text);
  } catch (err) {
    return false;
  }
}

export function tryExtractClientError(message: string) {
  try {
    const parsed = JSON.parse(message) as ClientError;
    if (parsed.status_code && parsed.status_text) return parsed;
  } catch (err) {}
}

/**
 * An error without sensitive info in its message.
 */
export class ClientSafeError extends Error {
  constructor(public clientError: ClientError) {
    super(JSON.stringify(clientError));
  }
}
